import { render } from "./GrossRevenue.vue?vue&type=template&id=07c241ba&scoped=true&ts=true"
import script from "./GrossRevenue.vue?vue&type=script&lang=ts"
export * from "./GrossRevenue.vue?vue&type=script&lang=ts"

import "./GrossRevenue.vue?vue&type=style&index=0&id=07c241ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c241ba"]])

export default __exports__